import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CrudStatus } from '../../../common/enums';
import { eventBus } from '../../../main';
import { IDocumentParamter } from '../../../models/documents';
import { IDocument } from '../../../models/documents/document';
import { ServiceBookService } from '../../../services/serviceBook.service';
import { DOCUMENT_GET_DOCUMENTS_ATTACHMENTS, DOCUMENT_MODULE_NAMESPACE, DOCUMENT_RESET_DOCUMENT, DOCUMENT_SAVE_DOCUMENT, DOCUMENT_SET_DOCUMENT, DOCUMENT_SET_DOCUMENTS_PAGINATION, DOCUMENT_SET_DOCUMENT_ACTION, DOCUMENT_SET_DOCUMENT_PARAMETER, DOCUMENT_UPDATE_DOCUMENT } from '../../../store/document';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../store/service-book';
import { IServiceBookDetails } from '../../../store/service-book/service-book-state.store';


const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component({
  name:'ServiceBookTickets',
  components: {
    'document-attachments': async () => import('@/containers/documents/components/document-attachments/DocumentsAttachments.vue'),
    'document-modal-vertical': async () => import('@/containers/documents/components/document-modal-vertical/DocumentModalVertical.vue')
  }
})
class ServiceBookDocuments extends Vue {


  @ServiceBookStore.Getter isLoading: boolean;
  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => void

  // === documents
  dtIsRecording: boolean
  dtErrorModalVisible: boolean
  dtError: any

  @DocumentStore.Getter documentCrudActionStatus: CrudStatus
  @DocumentStore.Getter document: IDocument
  @DocumentStore.Getter documentParameter: IDocumentParamter
  @DocumentStore.Getter paginationPage: number

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_ATTACHMENTS)
  storeGetDocumentAttachments: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_RESET_DOCUMENT)
  storeResetDocument: () => void

  @DocumentStore.Action(DOCUMENT_SAVE_DOCUMENT)
  storeRecordDocument: () => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_ACTION)
  storeSetDocumentCrudAction: (payload: CrudStatus) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT)
  storeSetDocumentByValue: (payload?: IDocument) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENTS_PAGINATION)
  storeSetDocumentPagination: (payload?: any) => void

  @DocumentStore.Action(DOCUMENT_UPDATE_DOCUMENT)
  storeUpdateDocument: () => Promise<any>
  _clearTimeout: any


  constructor() {
    super();
    this.dtIsRecording = false
    this.dtErrorModalVisible = false
    this.dtError = null
  }

  beforeMount()
  {
    const id = this.$route.params.id
    this.storeGetServiceBook(id)
  }

  mounted()
  {
    eventBus.$on('BLOCK_CREATE_DOCUMENT',()=>{
      this.storeSetDocumentByValue({blocks:this.blockId})
      this.storeSetDocumentCrudAction(CrudStatus.Create)
      this.isOpenModal = true
    })
  }

  beforeDestroy()
  {
    eventBus.$off('BLOCK_CREATE_DOCUMENT')
  }

  created() {
    console.log("document parameter init", this.documentParameter.fk_attachment_type)
    if (!this.documentParameter.fk_attachment_type || !this.documentParameter.fk_attachment_type.length) {
      // this.storeSetDocumentParameter({ $limit: 10 })
      console.log('set doc param', this.documentParameter)
    }
    // this.documentParameter.block = this.blockId
    this.storeSetDocumentParameter({ apartment:[Number(this.currentServiceBook.fk_apartment)], block:[Number(this.currentServiceBook.apartment.fk_apartment_block)], detail: 'true' })
  }


  get lblSetting() {
    return { ...require('@/locales/document').default }
  }

  get isCreateAction(): boolean {
    return this.documentCrudActionStatus === CrudStatus.Create
  }

  get isUpdateAction(): boolean {
    return this.documentCrudActionStatus === CrudStatus.Update
  }

  get isOpenModal(): boolean {
    return this.isCreateAction || this.isUpdateAction
  }

  set isOpenModal (value: boolean) {
    if (value) {
      // Update or create modal
      console.log('isOpenModal:', value)
    } else {
      this.storeSetDocumentCrudAction(CrudStatus.NoAction)
    }
  }

  get modalTitle() {
    return this.documentCrudActionStatus === CrudStatus.Create ? this.$t(this.lblSetting.documentAdd) : this.$t(this.lblSetting.documentEditOrShare)
  }

  get maxWidth(): string {
    return '90%';
  }

  get buttonText() {
    return this.$t(this.lblSetting.documentSave)
  }

  get hasntAttachment() {
    return !this.document.attachments || !this.document.attachments.length
  }
  get blockId (): number[] {
    return [parseInt(this.$route.params.id)]
  }

  handleBeforeModalClose() {
    this.storeResetDocument()
  }

  handleClose() { }

  handleSave() {
    this.dtIsRecording = true
    eventBus.$emit('DOC_SAVE_FILES_ATTRIBUTES')
    if (this.isCreateAction)
      this.storeRecordDocument()
        .then(response => {
          console.log('response=', response)
          this.$router.go(0)
        })
        .catch(err => {
          this.dtErrorModalVisible = true
          this.dtError = err
        })
        .finally(() => this.dtIsRecording = false)

    if (this.isUpdateAction)
      this.storeUpdateDocument()
        .then(response => {
          this.$router.go(0)
        })
        .catch(err => {
          this.dtErrorModalVisible = true
          this.dtError = err
        })
        .finally(() => this.dtIsRecording = false)
  }

  handleRemoveError() {
    this.dtErrorModalVisible = false
    this.dtError = null;
  }
  handleGetDocument () {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeGetDocumentAttachments().then(() => {})
    }, 500)
  }
  @Watch('documentParameter.key')
  handleKeyChanged() {
    if (this.paginationPage !== 1) {
      this.storeSetDocumentPagination({ page: 1 })
    }
    if (this.documentParameter.block !== this.blockId) {
      this.storeSetDocumentParameter({ block: this.blockId })
    }
    this.handleGetDocument()
  }


}

export default ServiceBookDocuments;



// WEBPACK FOOTER //
// ./src/containers/service-book/documents_UNUSED/index.ts